import { render, staticRenderFns } from "./DefaultTopNavbar.vue?vue&type=template&id=0a34b47a&scoped=true&"
import script from "./DefaultTopNavbar.vue?vue&type=script&lang=js&"
export * from "./DefaultTopNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a34b47a",
  null
  
)

export default component.exports